/** Visão geral: situação atual da operação e entregas do ano corrente. */
import { useEffect, useMemo, useState } from 'react'
import Layout from '../../components/Layout.jsx'
import { useApp } from '../../context/AppContext.jsx'
import { getOperacaoOverview } from '../../db/api.js'
import OperacaoOverview from './OperacaoOverview.jsx'
import './operacao-dashboard.css'

export default function OperacaoDashboard() {
  const { selectedClient } = useApp()
  // Remonta os dados ao trocar de conta: nenhuma resposta antiga fica visível.
  return <OperacaoClient key={selectedClient?.id || 'none'} clientId={selectedClient?.id} />
}

function OperacaoClient({ clientId }) {
  const [result, setResult] = useState(null)
  const [err, setErr] = useState(null)
  const [revision, setRevision] = useState(0)
  // Mantém o recorte anual usado anteriormente como padrão, sem filtros ocultos.
  const year = new Intl.DateTimeFormat('en', { year: 'numeric', timeZone: 'America/Sao_Paulo' }).format(new Date())
  const query = useMemo(() => ({ clientId, from: `${year}-01-01`, to: `${year}-12-31` }), [clientId, year])
  const queryKey = JSON.stringify(query)
  const data = result?.key === queryKey ? result.data : null
  useEffect(() => {
    let active = true
    setErr(null)
    if (!clientId) return undefined
    getOperacaoOverview(query).then(value => {
      if (active) setResult({ key: queryKey, data: value })
    }).catch(error => { if (active) setErr(error.message) })
    return () => { active = false }
  }, [query, queryKey, revision, clientId])

  return <Layout title="Operação" breadcrumb={[{ label: 'Operação' }]}>
    {!clientId ? <div className="od-state">Selecione uma conta para ver a operação.</div> : <div className="od-wrap">
      {err && <div className="od-state erro" role="alert">{err} <button className="od-btn" onClick={() => setRevision(v => v + 1)}>Tentar novamente</button></div>}
      {!data && !err && <div className="od-state" role="status">Carregando visão geral…</div>}
      {data && <OperacaoOverview key={queryKey} data={data} query={query} onRefresh={() => setRevision(v => v + 1)} />}
    </div>}
  </Layout>
}
